/**
 * Shared react-query defaults for the favorite-plans feature.
 *
 * `CACHE_TIME` holds the raw durations (ms); `QUERY_CONFIG` is the ready-to-spread
 * object with the cache + refetch behavior we want on these queries. Spread it into a
 * `useQuery` options object and override per hook as needed:
 *
 *   useQuery(key, fetcher, { ...QUERY_CONFIG, keepPreviousData: true });
 */
export const CACHE_TIME = {
    FIVE_MINUTES: 5 * 60 * 1000,
};

export const QUERY_CONFIG = {
    staleTime: CACHE_TIME.FIVE_MINUTES,
    cacheTime: CACHE_TIME.FIVE_MINUTES,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
};

/**
 * Config para las queries que alimentan el dashboard (lista de planes + métricas).
 *
 * El dashboard debe reflejar al instante el `usedCount` de cada template y las tarjetas de
 * métricas después de que el agente usa un template y crea una cotización (el back
 * incrementa esos contadores vía `myFavoritePlanId` en `/rate-engine/compute`). Con el
 * `staleTime` de 5 min de `QUERY_CONFIG`, al volver al dashboard dentro de esa ventana se
 * servían datos viejos. Aquí se fuerza refetch en cada montaje (el agente siempre re-monta
 * el dashboard al volver), conservando `cacheTime` para que `keepPreviousData` mantenga la
 * paginación/filtros fluidos.
 */
export const DASHBOARD_QUERY_CONFIG = {
    ...QUERY_CONFIG,
    staleTime: 0,
    refetchOnMount: 'always',
};

export default QUERY_CONFIG;
